import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import withWidth from '@material-ui/core/withWidth';
import { withStyles, createStyles } from '@material-ui/core';
import { green, grey } from '@material-ui/core/colors';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import useProvider from '../../../core/EcrionProvider/useProvider';
import request from '../../../utils/request';
import Formatter from '../../../formatter';
import Button from '../../../core/Button';

var styles = function styles(theme) {
  var fontSize = theme.typography.subtitle2.fontSize;
  return createStyles({
    button: {
      minWidth: 8 * 21
    },
    linkItem: {
      marginLeft: theme.spacing(3)
    },
    item: {
      marginBottom: theme.spacing(1)
    },
    circle: {
      height: fontSize,
      width: fontSize,
      minHeight: fontSize,
      minWidth: fontSize,
      borderRadius: '50%',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(1),
      '&:after': {
        content: '',
        display: 'block',
        paddingBottom: '100%'
      }
    },
    circleGreen: {
      backgroundColor: green[400]
    },
    circleGrey: {
      backgroundColor: grey[400]
    },
    formControl: {
      paddingLeft: theme.spacing(2),
      cursor: 'default'
    },
    label: {
      fontSize: fontSize
    },
    labelMerge: {
      fontSize: fontSize,
      marginLeft: theme.spacing(3)
    }
  });
};

var Crm = function Crm(_ref) {
  var routerLink = _ref.routerLink,
      classes = _ref.classes,
      width = _ref.width;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      integrationType = _useState2[0],
      setIntegrationType = _useState2[1];

  var providerProps = useProvider();
  var history = providerProps.routes && providerProps.routes.history;

  var openIntegrationPage = function openIntegrationPage() {
    history.push('/settings/integrations/crm');
  };

  useEffect(function () {
    var isMounted = true;
    request({
      url: '/backend/crm',
      data: {},
      method: 'GET'
    }).then(function (response) {
      if (isMounted) {
        if (!response) return;

        if (response.Connection) {
          var type = response.Connection.CRMType;
          if (type === 'salesforce') type = 'Salesforce';else if (type === 'dynamics') type = 'Microsoft Dynamics';else if (type === 'bpmonline') type = 'BPM Online';
          setIntegrationType(type);
        }
      }
    });
    return function () {
      isMounted = false;
    };
  }, []);
  return React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Typography, {
    variant: "subtitle1",
    className: classes.item
  }, React.createElement("b", null, "CRM"))), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Typography, {
    variant: "subtitle2",
    className: classes.item
  }, "Synchronize leads with Salesforce, Microsoft Dynamics or BPM Online.")), React.createElement(Grid, {
    container: true,
    item: true,
    alignItems: "center"
  }, React.createElement(Grid, {
    item: true,
    className: classes.item
  }, React.createElement(Button, {
    name: "configure-integration",
    onClick: openIntegrationPage,
    className: classes.button,
    disabled: !history
  }, "Configure Integration")), React.createElement(Grid, {
    container: true,
    item: true,
    xs: true,
    justify: "flex-start"
  }, React.createElement(Grid, {
    item: true,
    className: classes.item
  }, React.createElement(FormControlLabel, {
    control: React.createElement("span", {
      className: "".concat(classes.circle, " ").concat(integrationType !== '' ? classes.circleGreen : classes.circleGrey)
    }),
    label: integrationType !== '' ? width === 'lg' ? integrationType : 'Connected to ' + integrationType : 'No integrations',
    classes: {
      label: classes.label
    },
    className: classes.formControl
  })), React.createElement(Grid, {
    item: true,
    className: "".concat(classes.linkItem, "  ").concat(classes.item)
  }, integrationType !== '' && React.createElement(Formatter.Link, {
    text: "View Synchronization Log",
    to: "/settings/integrations/crm/log",
    style: {
      flex: 1
    },
    className: classes.label,
    component: routerLink
  })))));
};

export default withStyles(styles)(withWidth()(Crm));